import { DialogContentTextProps, DialogContentText as MuiDialogContentText } from "@mui/material";

type Props = DialogContentTextProps;

export const DialogContentText = ({ children, ...props }: Props) => {
  return <MuiDialogContentText {...props}>{children}</MuiDialogContentText>;
};
